"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnnouncedMessage = exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = require("react");
var ANNOUNCE_DELAY = 50;
var RESET_DELAY_DEFAULT = 1000;
var useAnnouncedMessage = exports.useAnnouncedMessage = function useAnnouncedMessage(_ref) {
  var _context, _context2;
  var announce = _ref.announce,
    message = _ref.message,
    onMessageAnnounced = _ref.onMessageAnnounced,
    _ref$resetDelay = _ref.resetDelay,
    resetDelay = _ref$resetDelay === void 0 ? RESET_DELAY_DEFAULT : _ref$resetDelay,
    _ref$disableReset = _ref.disableReset,
    disableReset = _ref$disableReset === void 0 ? false : _ref$disableReset;
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _useState = (0, _react.useState)(message),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    announcedMessage = _useState2[0],
    setAnnouncedMessage = _useState2[1];
  var setChildrenTimer;
  var resetTimer;
  (0, _react.useEffect)(function () {
    if (announce) {
      clearTimeout(setChildrenTimer);
      clearTimeout(resetTimer);
      setAnnouncedMessage('');
      // set timer to render message in order for JAWS to pick up
      // the span's update on initial load
      setChildrenTimer = setTimeout(function () {
        setAnnouncedMessage(message);
      }, ANNOUNCE_DELAY);
      if (!disableReset) {
        // set timer to reset message state and call consumer callback
        resetTimer = setTimeout(function () {
          setAnnouncedMessage('');
          onMessageAnnounced();
        }, resetDelay);
      }
    }
    return function () {
      clearTimeout(setChildrenTimer);
      clearTimeout(resetTimer);
    };
  }, (0, _concat.default)(_context = [announce]).call(_context, (0, _toConsumableArray2.default)(dependencies)));
  (0, _react.useEffect)(function () {
    if (!announce) {
      setAnnouncedMessage(message);
    }
  }, (0, _concat.default)(_context2 = [message]).call(_context2, (0, _toConsumableArray2.default)(dependencies)));
  return announcedMessage;
};
var _default = exports.default = useAnnouncedMessage;